import React from 'react';
import Nav from "./nav";

const Header = () => {
    return <header id="header"
            className="navbar navbar-expand navbar-fixed navbar-end navbar-light navbar-sticky-lg-top bg-white">
        <div className="container-fluid">
            <nav className="navbar-nav-wrap">
                <div className="row flex-grow-1">
                    <div className="docs-navbar-sidebar-container d-flex align-items-center mb-2 mb-lg-0">
                        <a className="navbar-brand" href="../snippets/index.html" aria-label="Space">
                            <img className="navbar-brand-logo" src="../assets/svg/logos/logo.svg" alt="Logo"/>
                        </a>
                    </div>
                    <div className="col-md px-lg-0">
                        <div className="d-flex justify-content-between align-items-center px-lg-5 px-xl-10">
                            <div className="d-none d-md-block">

                                <div className="d-none">
                                    <div id="searchTemplate" className="dropdown-item">
                                        <a className="d-block link" href="#">
                                            <span className="category d-block fw-normal text-muted mb-1"></span>
                                            <span className="component text-dark"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </header>
};

export default Header;